export default __webpack_public_path__ + "static/media/a1.2c5547a0.png";